import 'bootstrap';
import 'owl.carousel';
import 'bs5-lightbox';

$(document).ready(function() {
    
    $('.owl-carousel').owlCarousel({
        //animateOut: 'slideOutDown',
        //animateIn: 'flipInX',
			items:		1,
			loop:		true,
			autoplay:	true,
			mouseDrag: 	false,
			touchDrag: 	false,
			smartSpeed:	1500
    });


}); 